/**
 * DATA LAYER: DANCE CAM (BÁILELE) OVERLAY
 * Se encarga de la comunicación HTTP con la API de Dance Cam.
 */

export const GetDanceConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetDanceConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowDanceOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideDanceOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TriggerExplosion = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/explode`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ToggleFiestaMode = async (state) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/fiesta?state=${state}`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TriggerDancers = async (isFast, state = false) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}dance/dancers?isFast=${isFast}&state=${state}`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

